import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import _, { set } from 'lodash';
import { studentFetchMissions, updateMissionById } from '../../services2/missions.service';
import { studentConsent, studentFetchStudentMissions, studentFinishMission, studentFinishQuestionnaire, studentParticipateMission, studentStartMission, studentStartQuestionnaire, studentUpdateMissionById } from '../../services2/studentMissions.service';
import MDEditor from '@uiw/react-md-editor';
import MenuSvg from '../../svg/Menu';
import LogoSvg from '../../svg/Logo.js';
import HomeButtonSvg from '../../svg/HomeButton.js';
import ArrowNextSvg from '../../svg/ArrowNext.js';
import LogoNoText from '../../svg/LogoNoText.js';
import CrossSvg from '../../svg/admin/Remove.js';
import InquirySvg from '../../svg/student/Inquiry.js';
import LeftArrowSvg from '../../svg/student/Left.js';
import RightArrowSvg from '../../svg/student/Right.js';
import PreviousSvg from '../../svg/student/Previous.js';
import NextSvg from '../../svg/student/Next.js';
import ReloadSvg from '../../svg/student/Reload.js';
import Instructions from './Instructions.js';
import Timer from './components/Timer.js'
import PopupWindow from '../admin/components/TextPopupWindow';
import { fetchSchoolMissions } from '../../services2/schoolMissions.service.js';
import { fetchQuestionnaireById } from '../../services2/questionnaires.service.js';
import DatePicker from './components/DatePicker.js';
const dragAndDropWidth = 180
const dragAndDropHeight = 90

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setdata] = useState(null)
    const [mission, setmission] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const isMobile = window.innerWidth <= 1024
    const isSuperSmall = window.innerWidth <= 600

    const fetchData = async () => {
        let result = await studentFetchMissions(props.token.token, { _id: id });
        if (result.result) {
            setdata(result.result?.[0] || {})
        } else {
            alert('Fetch data error')
        }
    }
    const fetchMission = async () => {
        let result = await studentFetchStudentMissions(props.token.token, { missionId: id });
        if (result.result) {
            setmission(result.result?.[0] || null)
        } else {
            alert('Fetch data error')
        }
    }
    const [schoolMission, setschoolMission] = useState(null)
    const [questionnaires, setQuestionnaires] = useState(null)
    const fetchSchoolMission = async () => {
        let result = await fetchSchoolMissions(props.token.token, { isPublic: true, missionId: id }, { limit: 99 });
        if (result?.result?.[0]) {
            setschoolMission(result?.result?.[0] || null)
            if (result.result?.[0]?.questionnaire2Id) {
                let questionnaireResult = await fetchQuestionnaireById(props.token.token, result.result[0]?.questionnaire2Id);
                console.log(questionnaireResult)
                if (questionnaireResult.result) {
                    setQuestionnaires(questionnaireResult.result)
                } else {
                    alert('Fetch data error')
                }
            }
        } else {
            alert('Fetch data error')
        }
    }

    const handleStartMission = async () => {
        setisLoading(true)
        if (!mission) {
            let result = await studentParticipateMission(props.token.token, id);
            if (result.result) {
                setmission(result.result)
                await fetchMission()
                setisDoingMission(true)
            } else {
                alert(JSON.stringify(result?.message))
            }
        } else {
            setisDoingMission(true)
        }
        setisLoading(false)
    }

    const refresh = async () => {
        if (isLoading) return
        setisLoading(true)
        await fetchData()
        await fetchMission()
        await fetchSchoolMission()
        setisLoading(false)
    }

    useEffect(() => {
        refresh()
    }, [id])

    const handleConsent = (boo) => async () => {
        setisLoading(true)
        let result = await studentConsent(props.token.token, mission._id, boo);
        if (result.result) {
            await fetchMission()
        } else {
            alert(JSON.stringify(result?.message))
        }
        setisLoading(false)
    }



    const [isDoingMission, setisDoingMission] = useState(false);
    const [remainingTime, setremainingTime] = useState(0);
    useEffect(() => {
        let timeInterval = null
        if (!isDoingMission) { return }
        if (!mission?.startTime) { return }
        if (!mission?.time) { return }
        timeInterval = setInterval(() => {
            let second = (new Date(mission.startTime).getTime() + mission.time * 60 * 1000 - Date.now()) / 1000
            setremainingTime(second <= 0 ? 0 : second)
        }
            , 1000)
        return () => { clearInterval(timeInterval) }
    }, [mission, isDoingMission,])


    const autoSubmit = async () => {
        setisLoading(true)
        let result = await studentFinishMission(props.token.token, mission._id, mission.questions, progress)
        if (result.result) {
            await fetchMission()
        } else {
            console.log(JSON.stringify(result?.message))
        }
        setisLoading(false)
    }
    useEffect(() => {
        if (mission?.status === '進行中') {
            if (new Date(mission.startTime).getTime() + mission.time * 60 * 1000 - Date.now() <= 0) {
                alert('時間到');
                autoSubmit();
            }
        }
    }, [mission, remainingTime])

    const getRemainingTimeString = () => {
        if ((!remainingTime) || remainingTime <= 0) return '00:00'
        let time = remainingTime
        let hours = Math.floor(time / 3600);
        let minutes = Math.floor((time - (hours * 3600)) / 60);
        let seconds = Math.floor(time - (hours * 3600) - (minutes * 60));
        //return `${hours < 10 ? `0` : ''}${hours}:${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
        return `${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
    }
    const [questionIndex, setquestionIndex] = useState(0);
    const selectQuestion = (item, index) => () => {
        if (index <= progress)
            setquestionIndex(index)
    }
    const progress = mission?.progress || 0

    const [selectedDragOption, setselectedDragOption] = useState(null)
    useEffect(() => { setselectedDragOption(null) }, [questionIndex])

    const handleStart = async () => {
        setisLoading(true)
        let result = await studentStartMission(props.token.token, mission._id);
        if (result.result) {
            await fetchMission()
        } else {
            alert(JSON.stringify(result?.message))
        }
        setisLoading(false)
    }

    const [tabIndex, settabIndex] = useState(0);

    const [dragSource, setdragSource] = useState(null)

    const handlePreviousQuestion = async () => {
        if (questionIndex === 0) return
        setisLoading(true)
        let pages = mission?.pages
        let result = await studentUpdateMissionById(props.token?.token, mission._id, {
            questions: mission?.questions,
            progress,
            pages,
        })
        if (result.result) {
            await fetchMission()
            setquestionIndex(questionIndex - 1)
        } else {
            alert(JSON.stringify(result?.message))
        }
        setisLoading(false)
    }

    const handleNextQuestion = async () => {
        if (['選擇題', '選擇題 + 短句作答題'].includes(mission?.questions?.[questionIndex].type)) {
            if (mission?.questions?.[questionIndex].options?.filter(option => option.isSelected).length === 0) {
                alert('請選擇答案')
                return
            }
        }
        if (['短句作答題', '選擇題 + 短句作答題'].includes(mission?.questions?.[questionIndex].type)) {
            if (!mission?.questions?.[questionIndex].answer) {
                alert('請回答問題')
                return
            }
        }
        if (['表格問題'].includes(mission?.questions?.[questionIndex].type)) {
            if (mission?.questions?.[questionIndex].multipleChoiceType !== '多項選擇題') {
                if (mission?.questions?.[questionIndex]?.table?.filter(row => ((!row.answer1) && (!row.answer2))).length > 0) {
                    alert('請選擇答案')
                    return
                }
            }
        }
        if (questionIndex === mission?.questions?.length - 1) {
            setshowReadySubmitPopup(true)
            return
        }


        setisLoading(true)
        let pages = mission?.pages
        if (mission?.questions?.[questionIndex + 1].popupPageId) {
            pages = mission?.pages.map(p => ({ ...p, initial: (p.id === mission?.questions?.[questionIndex + 1].popupPageId) ? true : (p.initial || false) }))
        }
        let result = await studentUpdateMissionById(props.token?.token, mission._id, {
            questions: mission?.questions,
            progress: Math.max(Number(questionIndex) + 1, progress),
            pages,
        })
        if (result.result) {
            await fetchMission()
            setquestionIndex(questionIndex + 1)
            if (mission?.questions?.[questionIndex + 1].popupPageId) {
                settabIndex(mission?.pages.findIndex(p => p.id == mission?.questions?.[questionIndex + 1].popupPageId))
            }
        } else {
            alert(JSON.stringify(result?.message))
        }
        setisLoading(false)
    }

    const isDraggable = (optionIndex) => {
        for (let column of mission?.questions[questionIndex]?.dragAndDrop) {
            for (let row of column?.rows) {
                if (row.studentAnswer === mission?.questions[questionIndex]?.dragAndDropOptions?.[optionIndex]?.text) {
                    return false
                }
            }
        }
        return true
    }

    const [isShowInstruction, setisShowInstruction] = useState(false)

    const handleStartQuestionnaire = async () => {
        setisLoading(true)
        let result = await studentStartQuestionnaire(props.token.token, mission._id);
        if (result.result) {
            await fetchMission()
        } else {
            alert(JSON.stringify(result?.message))
        }
        setisLoading(false)
    }
    function isCompleteQuestionnaire() {
        if (!questionnaires.questionnaires2) return false
        for (let question of questionnaires.questionnaires2) {
            if (question.type === '選擇題' || question.type === '選擇題 + 短句作答題') {
                if (!question.options?.filter(option => option.isSelected).length) {
                    return false
                }
            }
            if (question.type === '短句作答題' || question.type === '選擇題 + 短句作答題') {
                if (!question.answer) {
                    return false
                }
            }
            if (question.type === '表格問題') {
                if (question.rows?.some(row => ((row.answer === undefined)))) {
                    return false
                }
            }
        }
        return true
    }
    const handleFinishQuestionnaire = async () => {
        if (!isCompleteQuestionnaire()) {
            alert('請完成所有問題')
            return
        }
        setisLoading(true)
        let result = await studentFinishQuestionnaire(props.token.token, mission._id, questionnaires.questionnaires2)
        if (result.result) {
            await fetchMission()
        } else {
            alert(JSON.stringify(result?.message))
        }
        setisLoading(false)
    }

    const [showReadySubmitPopup, setshowReadySubmitPopup] = useState(false)
    const handleSubmitTask = async () => {
        setisLoading(true)
        let result = await studentFinishMission(props.token.token, mission._id, mission.questions, progress)
        if (result.result) {
            await fetchMission()
            setshowReadySubmitPopup(false)
        } else {
            alert(JSON.stringify(result?.message))
        }
        setisLoading(false)
        return
    }

    const [isShowPopup, setisShowPopup] = useState(false)


    if (mission?.finishTime && !mission.questionnaire2StartTime && schoolMission?.questionnaire2Id) {
        return (<div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            {/*buttons*/}
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { navigate('/platform2/missions') }}>{`<`} 返回</div>
            </div>
            {/*end of buttons*/}
            <div className='flex-[3] flex flex-col gap-[16px] min-w-[300px]'>
                <div className='font-[700]'>閲讀任務: {mission?.name}</div>
                <div className='font-[700]'>問卷調查:</div>
                <div>您有 {questionnaires?.time_2} 分鐘完成問卷</div>
                <div className='flex flex-row gap-[16px]'>
                    <div onClick={handleStartQuestionnaire} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#8866ff] text-[white]'>
                        {'開始'}
                    </div>
                </div>
            </div>
        </div>)
    }

    if (mission?.finishTime && !mission.questionnaire2FinishTime && schoolMission?.questionnaire2Id) {
        return (<div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-d-16 text-[black]' style={{ overflowY: "auto" }}>
            {/*buttons*/}
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { navigate('/platform2/missions') }}>{`<`} 返回</div>
            </div>
            {/*end of buttons*/}

            {questionnaires?.questionnaires2?.map((questionnaire, index) =>
                <div key={questionnaire.id || index} className='w-full mb-[64px]' style={{}}>
                    <div className='font-[700] mt-[16px]'>問題 {index + 1}</div>
                    {['短句作答題'].includes(questionnaire.type) || <MDEditor.Markdown source={questionnaire?.question || ''} style={{ fontSize: isMobile ? 16 : 25, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />}
                    {['選擇題', '選擇題 + 短句作答題'].includes(questionnaire.type) &&
                        <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                            {questionnaire?.options?.map((option, optionIndex) => (
                                <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                    <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                        <button onClick={() => {
                                            let questionnaires_ = { ...questionnaires }
                                            if (questionnaire.multipleChoiceType !== '多項選擇題') {
                                                questionnaires_.questionnaires2[index].options = questionnaires_.questionnaires2[index].options.map(option => ({ ...option, isSelected: false }))
                                                questionnaires_.questionnaires2[index].options[optionIndex].isSelected = true
                                            } else {
                                                questionnaires_.questionnaires2[index].options[optionIndex].isSelected = !questionnaires_?.questionnaires2?.[index].options[optionIndex].isSelected
                                            }
                                            setQuestionnaires(questionnaires_)
                                        }}
                                            className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.isSelected ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                        ></button>
                                    </div>
                                    {option.text}
                                </div>
                            ))}
                        </div>
                    }
                   
                    {['短句作答題', '選擇題 + 短句作答題'].includes(questionnaire?.type) && (
                        <div className='w-fill mt-[16px] flex flex-col p-[2px]'>
                            <MDEditor.Markdown source={questionnaire?.questionShortanswer || ''} style={{ fontSize: isMobile ? 16 : 25, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />
                            { questionnaire?.isDate?
                            <DatePicker value={questionnaire?.answer || ''} onChange={(val)=>{
                                let questionnaires_ = { ...questionnaires }
                                questionnaires_.questionnaires2[index].answer = val
                                setQuestionnaires(questionnaires_)
                            }}/>
                            :<textarea
                                className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[2px] mt-[16px]' style={{ border: '1px solid #00000080', boxShadow: '0px 0px 2px 2px rgb(217,229,193)' }}
                                value={questionnaire?.answer || ''}
                                onChange={(e) => {
                                    let questionnaires_ = { ...questionnaires }
                                    questionnaires_.questionnaires2[index].answer = e.target.value
                                    setQuestionnaires(questionnaires_)
                                }}
                            />}
                        </div>
                    )}
                    {/*end of open end question*/}

                    {['表格問題'].includes(questionnaire?.type) &&
                        <div className='w-fill mt-[16px] flex flex-col p-[2px] gap-[16px]'>
                            <div className='w-full flex flex-row gap-[16px]'>
                                <div className='flex-1 max-w-[150px]'>
                                </div>
                                {questionnaire?.options?.map((option, optionIndex) =>
                                    <div key={optionIndex} className='flex-1 flex justify-center items-center max-w-[150px]'>
                                        <div>{option?.text}</div>
                                    </div>
                                )}
                            </div>
                            {questionnaire?.rows?.map((row, rowIndex) =>
                                <div key={rowIndex} className='w-full flex flex-row gap-[16px]'>
                                    <div className='flex-1 max-w-[150px]'>
                                        {row?.text}
                                    </div>
                                    {questionnaire?.options?.map((option, optionIndex) =>
                                        <div key={optionIndex} className='flex-1 flex justify-center items-center max-w-[150px]'>
                                            <button onClick={() => {
                                                let questionnaires_ = { ...questionnaires }
                                                questionnaires_.questionnaires2[index].rows[rowIndex].answer = optionIndex
                                                setQuestionnaires(questionnaires_)
                                            }}
                                                className={`w-[20px] h-[20px] rounded-full border-[1px] border-[black] ${row?.answer === optionIndex ? 'bg-gray-500' : 'bg-[#fafafa]'}`}
                                            ></button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    }

                </div>
            )}

            <div className='flex flex-row gap-[16px]'>
                <div onClick={(handleFinishQuestionnaire)} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#8866ff] text-[white]'>
                    提交
                </div>
            </div>

        </div>)
    }

    if (mission?.finishTime) {
        return (
            <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
                {/*buttons*/}
                <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                    <div className='text-[#1D1D41]  text-d-24 font-[400] cursor-pointer' onClick={() => { navigate('/platform2/missions') }}>{`<`} 返回</div>
                </div>
                {/*end of buttons*/}

                <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap'>
                    <div className='flex-[3] flex flex-col gap-[16px] min-w-[300px]'>
                        <div className='font-[700]'>閲讀任務: {data?.name}</div>
                        <div>
                            已經完成任務
                        </div>
                        <div>
                            <button onClick={() => { navigate(`/platform2/studentmissions/${mission?._id}`) }} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#8866ff] text-[white]'>
                                查看結果
                            </button>
                        </div>
                    </div>
                </div>
                {isLoading && <LoadingPage />}
            </div>
        )
    }
    if (isDoingMission && !mission?.consentTime) {
        return (
            <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
                {/*buttons*/}
                <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                    <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { setisDoingMission(false) }}>{`<`} 返回</div>
                </div>
                {/*end of buttons*/}
                <div className='flex-[3] flex flex-col gap-[16px] min-w-[300px]'>
                    <div className='font-[700]'>閲讀任務: {mission?.name}</div>
                    <div className='font-[400]'>
                        {/* 同意書:<br /> */}
                        <div className='w-full bg-[white] p-[16px] rounded-[10px] mt-[16px]'>
                            <MDEditor.Markdown source={mission?.consent || ''} style={{ fontSize: isMobile ? 12 : 16, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "white" }} />
                        </div>
                    </div>
                    <div className='flex flex-row gap-[16px]'>
                        <div onClick={handleConsent(true)} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[10px] rounded-[7px] bg-[#8866ff] text-[white]'>
                            {'同意'}
                        </div>
                        <div onClick={handleConsent(false)} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[10px] rounded-[7px] bg-[#aaa] text-[white]'>
                            {'不同意'}
                        </div>
                    </div>
                    <div className='w-full bg-[white] p-[16px] rounded-[10px] mt-[16px]'>
                        <MDEditor.Markdown source={mission?.consentRemarks || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "white" }} />
                    </div>
                </div>

            </div>
        )
    }

    if (isDoingMission && !mission.startTime) {
        return (
            <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
                {/*buttons*/}
                <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                    <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { setisDoingMission(false) }}>{`<`} 返回</div>
                </div>
                {/*end of buttons*/}
                <div className='flex-[3] flex flex-col gap-[16px] min-w-[300px]'>
                    <div className='font-[700]'>閲讀任務: {mission?.name}</div>
                    <div className='font-[400]'>時間: {mission.time} 分鐘<br />
                        {/* <div className='w-full bg-[white] p-[16px] rounded-[10px] mt-[16px]'>
                        <MDEditor.Markdown source={mission?.description||''} style={{ whiteSpace: 'pre-wrap',color:"black",backgroundColor:"white",}} />
                    </div> */}
                    </div>
                    <div className='flex flex-row gap-[16px]'>
                        <div onClick={handleStart} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#8866ff] text-[white]'>
                            開始任務
                        </div>
                        <div onClick={() => { setisDoingMission(false) }} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#aaa] text-[white]'>
                            返回
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    if (isDoingMission)
        return (
            <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[black]' style={{ overflowY: "auto",fontSize:isMobile?12:16 }}>
                {/*header*/}
                <div className='w-full flex flex-row justify-between items-center bg-[white]' style={{gap:isMobile?'4px':'16px',overflow:'auto',paddingLeft:isMobile?8:24,paddingRight:isMobile?8:24,height:isMobile?55:80}}>
                    <div className='text-[32px] font-[700] text-[#1F4CC8]' style={{display:isSuperSmall?'none':'flex'}}>
                        <LogoNoText width={isMobile ? '60px' : '90px'} />
                    </div>
                    {/* <div className='bg-[#00E6BD] rounded-[24px] h-[48px] font-[700] text-[#001D37] px-[24px] flex flex-row items-center' style={{ boxShadow: '4px 4px 16px 0px #5C5C5C4D', border: "2px solid white" }} >
                        {getRemainingTimeString()}
                    </div> */}
                    <div className='flex-1 flex flex-row justify-start items-center' style={{ marginLeft: isMobile ? 5 : 32,gap:isMobile?'4px':'24px' }}>
                        {isMobile ? <div className='bg-[#C3E9FF] flex flex-row p-[2px] gap-[2px]'>
                            {mission?.questions?.map((item, index) =>
                                <div onClick={selectQuestion(item, index)} key={item?.id || index} className='h-[24px] w-[18px] cursor-pointer flex flex-row justify-center items-center font-[700]' style={{ backgroundColor: index === questionIndex ? '#1F4CC8' : index <= progress ? '#00E9BA' : 'white', border: '2px solid #D9D9D9' }}>
                                    {/* {index + 1} */}
                                </div>
                            )}
                        </div>
                            : <div className='bg-[#C3E9FF] flex flex-row p-[6px] gap-[6px]'>
                                {mission?.questions?.map((item, index) =>
                                    <div onClick={selectQuestion(item, index)} key={item?.id || index} className='h-[48px] w-[36px] cursor-pointer flex flex-row justify-center items-center font-[700]' style={{ backgroundColor: index === questionIndex ? '#1F4CC8' : index <= progress ? '#00E9BA' : 'white', border: '2px solid #D9D9D9' }}>
                                        {/* {index + 1} */}
                                    </div>
                                )}
                            </div>}
                        <Timer text={getRemainingTimeString()} percentage={(1 - ((remainingTime || 0) / ((mission.time * 60) || 1))) * 100} />
                    </div>
                    <div className='flex flex-row items-center' style={{ gap:isMobile?'8px':'16px' }}>
                        <div onClick={() => { setisShowInstruction(true) }} style={{width:isMobile?36:48,height:isMobile?36:48}} className=' rounded-[7px] bg-[#00E9BA] flex justify-center items-center cursor-pointer hover:opacity-[0.8]'>
                            <InquirySvg width={isMobile?24:36} height={isMobile?24:36} />
                        </div>
                        <div onClick={handlePreviousQuestion} style={{width:isMobile?36:48,height:isMobile?36:48,marginLeft:isMobile?8:36}} className='rounded-[7px] bg-[#1F4CC8] flex justify-center items-center cursor-pointer hover:opacity-[0.8]'>
                            <LeftArrowSvg width={isMobile?24:36} height={isMobile?24:36} />
                        </div>
                        <div onClick={handleNextQuestion} style={{width:isMobile?36:48,height:isMobile?36:48}} className=' rounded-[7px] bg-[#1F4CC8] flex justify-center items-center cursor-pointer hover:opacity-[0.8]'>
                            <RightArrowSvg width={isMobile?24:36} height={isMobile?24:36} />
                        </div>
                    </div>
                </div>
                {/*end of header*/}

                {/*content*/}
                <div className='flex flex-row w-full flex-1 bg-[#D9D9D9]' style={{ overflow: 'hidden',padding:isMobile?2:10,gap:isMobile?2:10 }}>
                    {/*question*/}
                    <div className='flex flex-col h-full bg-[white] justify-start items-start text-[black]' style={{ border:isMobile?"4px solid #E3F5FF": '10px solid #E3F5FF',gap:isMobile?8:16,padding:isMobile?4:16,fontSize:isMobile?12:16,width:isMobile?500:600 }}>
                        <div className='w-full bg-[#1F4CC8] text-[white]' style={{padding:isMobile?6:16,fontSize:isMobile?12:16}}>
                            <div className='font-[700]' style={{fontSize:isMobile?16:24}}>{mission?.name}</div>
                            <div>問題 {questionIndex + 1} / {mission?.questions.length}</div>
                        </div>
                        <div className='italic'>
                            {mission?.questions?.[questionIndex]?.dialog}
                        </div>
                        <div className='flex-1 w-full' style={{ overflowY: 'auto' }}>
                            {['短句作答題'].includes(mission?.questions?.[questionIndex].type) || <MDEditor.Markdown source={mission?.questions?.[questionIndex]?.question || ''} style={{fontSize:isMobile?12:16, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />}
                            {['選擇題', '選擇題 + 短句作答題'].includes(mission?.questions?.[questionIndex].type) &&
                                <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                                    {mission?.questions?.[questionIndex]?.options?.map((option, optionIndex) => (
                                        <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let mission_ = { ...mission }
                                                    if (mission_.questions[questionIndex].multipleChoiceType !== '多項選擇題') {
                                                        mission_.questions[questionIndex].options = mission_.questions[questionIndex].options.map(option => ({ ...option, isSelected: false }))
                                                        mission_.questions[questionIndex].options[optionIndex].isSelected = true
                                                    } else {
                                                        mission_.questions[questionIndex].options[optionIndex].isSelected = !mission_?.questions?.[questionIndex].options[optionIndex].isSelected
                                                    }
                                                    setmission(mission_)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.isSelected ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            {option.text}
                                        </div>
                                    ))}
                                </div>
                            }
                            {['短句作答題', '選擇題 + 短句作答題'].includes(mission?.questions[questionIndex]?.type) && (
                                <div className='w-fill mt-[16px] flex flex-col p-[2px]'>
                                    <MDEditor.Markdown source={mission?.questions?.[questionIndex]?.questionShortanswer || ''} style={{ whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent",fontSize:isMobile?12:16 }} />
                                    {/* no allow copy and paste */}
                                    <textarea
                                        className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[2px] mt-[16px]' style={{ border: '1px solid #00000080', boxShadow: '0px 0px 2px 2px rgb(217,229,193)' ,padding:isMobile?4:16}}
                                        value={mission?.questions?.[questionIndex]?.answer || ''}
                                        maxLength={120}
                                        placeholder='請輸入答案'
                                        onPaste={(e) => {
                                            //disable paste
                                            e.preventDefault()
                                            return false
                                        }}
                                        onChange={(e) => {
                                            let mission_ = { ...mission }
                                            mission_.questions[questionIndex].answer = e.target.value
                                            setmission(mission_)
                                        }}
                                    />
                                </div>
                            )}
                            {/*end of open end question*/}


                            {['表格問題'].includes(mission?.questions[questionIndex]?.type) && (
                                <div className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[7px] mt-[24px]'>
                                    <div className='flex flex-col w-full'>
                                        <div className='flex flex-row items-stretch w-full border-black font-[700]'>
                                            <div className='bg-[#777] text-white flex-1 border-[black] border-[1px] w-full px-[12px] py-[4px] flex items-center justify-center'>
                                                {mission.questions[questionIndex]?.header?.[0] || ''}
                                            </div>
                                            <div className='bg-[#777] text-white border-[black] border-[1px] px-[12px] py-[4px] text-center flex items-center justify-center' style={{width:isMobile?70:100}}>
                                                {mission.questions[questionIndex]?.header?.[1] || ''}
                                            </div>
                                            <div className='bg-[#777] text-white border-[black] border-[1px] px-[12px] py-[4px]  text-center flex items-center justify-center' style={{width:isMobile?70:100}}>
                                                {mission.questions[questionIndex]?.header?.[2] || ''}
                                            </div>
                                        </div>
                                        {mission?.questions[questionIndex]?.table?.map((row, rowIndex) => (
                                            <div key={rowIndex} className='flex flex-row items-stretch'>
                                                <div className='flex-1 bg-[#F0F0F0] border-black border-x-[1px] border-y-[1px] px-[12px] py-[4px]'>{row.text}</div>
                                                <div className='border-[black] border-[1px] px-[12px] py-[4px] flex flex-row justify-center items-center bg-[#F0F0F0]' style={{width:isMobile?70:100}}>
                                                    <div>
                                                        <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                            <button
                                                                className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.answer1 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                                onClick={() => {
                                                                    let mission_ = { ...mission }
                                                                    if (mission_.questions[questionIndex]?.data?.multipleChoiceType !== '多項選擇題') {
                                                                        mission_.questions[questionIndex].table[rowIndex].answer1 = true
                                                                        mission_.questions[questionIndex].table[rowIndex].answer2 = false
                                                                    } else
                                                                        mission_.questions[questionIndex].table[rowIndex].answer1 = !mission_.questions[questionIndex].table[rowIndex].answer1
                                                                    setmission(mission_)
                                                                }}
                                                            ></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=' border-[black] border-[1px] px-[12px] py-[4px] flex flex-row justify-center justify-center items-center bg-[#F0F0F0]' style={{width:isMobile?70:100}}>
                                                    <div>
                                                        <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                            <button
                                                                className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.answer2 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                                onClick={() => {
                                                                    let mission_ = { ...mission }
                                                                    if (mission_.questions[questionIndex]?.data?.multipleChoiceType !== '多項選擇題') {
                                                                        mission_.questions[questionIndex].table[rowIndex].answer2 = true
                                                                        mission_.questions[questionIndex].table[rowIndex].answer1 = false
                                                                    } else
                                                                        mission_.questions[questionIndex].table[rowIndex].answer2 = !mission_.questions[questionIndex].table[rowIndex].answer2
                                                                    setmission(mission_)
                                                                }}
                                                            ></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {/*end of form table question*/}


                            {/*drag and drop question*/}
                            {['拖放式問題'].includes(mission?.questions[questionIndex]?.type) && (
                                <div className='w-full flex flex-col bg-[#F8F8F8] gap-[8px] rounded-[7px]' style={{padding:isMobile?4:16}}>
                                    <div className='w-full flex flex-row justify-start items-stretch'>
                                        {mission?.questions[questionIndex]?.dragAndDrop?.map((column, columnIndex) =>
                                            <div key={columnIndex} className='bg-[rgb(210,210,210)] p-[2px] min-w-[100px] form-input flex flex-col'>
                                                <div className='flex flex-col flex-[1] w-full gap-[4px]'>
                                                    <div className='bg-[rgb(230,238,247)] text-black w-full font-[700] px-[12px] py-[4px]'>
                                                        {column?.title || ''}
                                                    </div>

                                                    {column?.rows?.map((row, rowIndex) =>
                                                        <div key={rowIndex} className='p-[2px] relative'>
                                                            {row?.type === '拖放格' && <div className='relative cursor-pointer bg-white flex flex-col items-center justify-center p-[4px]'
                                                                onDragOver={(e) => { e.preventDefault(); }}
                                                                onDrop={(e) => {
                                                                    if (dragSource !== null) {
                                                                        setselectedDragOption(null)
                                                                        let mission_ = { ...mission }
                                                                        mission_.questions[questionIndex].dragAndDrop[columnIndex].rows[rowIndex].studentAnswer = mission_.questions[questionIndex].dragAndDropOptions[dragSource].text
                                                                        setmission(mission_)
                                                                        setdragSource(null)
                                                                    }
                                                                }}
                                                                onClick={() => {
                                                                    if (selectedDragOption !== null) {
                                                                        let mission_ = { ...mission }
                                                                        mission_.questions[questionIndex].dragAndDrop[columnIndex].rows[rowIndex].studentAnswer = mission_.questions[questionIndex].dragAndDropOptions[selectedDragOption].text
                                                                        setmission(mission_)
                                                                        setselectedDragOption(null)
                                                                        setdragSource(null)
                                                                    }
                                                                }}
                                                                style={{ width: isMobile?dragAndDropWidth/1.5:dragAndDropWidth, height: (isMobile?dragAndDropHeight/1.5:dragAndDropHeight )* (row.size || 1), border: row?.studentAnswer ? '1px solid black' : 'none' }}>
                                                                {/* <DropDownMenu value={row.answer||'--- 無 ---'} options={['--- 無 ---',...(item?.data?.dragAndDropOptions||[]).map((o)=>o.text)]} select={
                                                                (type)=>{if(props.onEditKey)props.onEditKey(item,index,'dragAndDrop',[...item.data?.dragAndDrop.slice(0,columnIndex),{...column,rows:[...column?.rows.slice(0,rowIndex),{...row,answer:type},...column?.rows.slice(rowIndex+1)]},...item.data?.dragAndDrop.slice(columnIndex+1)])}
                                                            }/> */}
                                                                {row?.studentAnswer || ''}
                                                                {row?.studentAnswer && <div className='absolute top-[2px] right-[2px] cursor-pointer' onClick={() => {
                                                                    let mission_ = { ...mission }
                                                                    mission_.questions[questionIndex].dragAndDrop[columnIndex].rows[rowIndex].studentAnswer = null
                                                                    setmission(mission_)
                                                                }}>
                                                                    <CrossSvg />
                                                                </div>}
                                                            </div>}
                                                            {row?.type === '文字' && <div className='bg-white flex flex-col' style={{ width: isMobile?dragAndDropWidth/1.5:dragAndDropWidth, height: (isMobile?dragAndDropHeight/1.5:dragAndDropHeight) * (row.size || 1) }}>
                                                                <div className='px-[16px] py-[6px] rounded-[7px] w-full h-full flex items-center justify-center' >
                                                                    {row?.text || ''}
                                                                </div>
                                                            </div>}
                                                            {row?.type === '空白區域' && <div className='flex flex-col' style={{ width: isMobile?dragAndDropWidth/1.5:dragAndDropWidth, height: (isMobile?dragAndDropHeight/1.5:dragAndDropHeight) * (row.size || 1) }}>

                                                            </div>}

                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className='flex flex-row w-full gap-[2%] flex-wrap'>
                                        {mission?.questions[questionIndex]?.dragAndDropOptions?.map((option, optionIndex) => (
                                            <div className='flex flex-row items-center cursor-pointer bg-[white] rounded-[2px] select-none w-[32%] mb-[8px]'
                                                draggable={isDraggable(optionIndex)} key={optionIndex}
                                                onDragStart={(e) => { setdragSource(optionIndex) }}
                                                onDragEnd={(e) => { setdragSource(null) }}
                                                onDragOver={(e) => { e.preventDefault(); }}
                                                onClick={() => {
                                                    if (isDraggable(optionIndex))
                                                        setselectedDragOption(optionIndex === selectedDragOption ? null : optionIndex)
                                                }}
                                                // onTouchStart={(e)=>{setdragSource(optionIndex)}}
                                                // onTouchEnd={(e)=>{setdragSource(null)}}
                                                style={{ aspectRatio: 1, opacity: isDraggable(optionIndex) ? 1 : .3, border: optionIndex === selectedDragOption ? '2px solid blue' : '1px solid black', boxShadow: dragSource === optionIndex ? '0px 0px 2px 2px green' : '0px 0px 1px 1px #00000080' }}>

                                                <div className=' px-[12px] py-[4px]]'>
                                                    {option.text}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </div>
                        {/* <div className='flex w-full flex flex-col p-[16px]'>
                            <div onClick={handleNextQuestion} className='font-[700] cursor-pointer hover:opacity-[0.8] px-[32px] py-[16px] rounded-[7px] bg-[#1F4CC8] text-[white] text-center'>
                                保存並繼續
                            </div>
                        </div> */}
                    </div>
                    {/*end of question*/}

                    {/*webpages*/}
                    <div className='flex flex-col w-full bg-[#EEF2F6]' style={{ border: isMobile?'2px solid #EEF2F6':'10px solid #EEF2F6' }}>
                        {/*tabs*/}
                        <div className='flex flex-row w-full items-end justify-start bg-[white]' style={{ border: '2px solid #D9D9D9',paddingLeft:isMobile?4:16,paddingRight:isMobile?4:16,gap:isMobile?2:8 ,paddingTop:isMobile?2:6}} >
                            {mission?.pages?.map((page, index) =>
                                page?.initial ?
                                    <div onClick={() => { settabIndex(index) }} key={page.id || index} className='flex flex-row items-center gap-[8px] px-[12px] py-[4px] cursor-pointer hover:opacity-[.7] mb-[-2px]' style={{ backgroundColor: tabIndex === index ? '#EEF2F6' : 'white', borderTop: '2px solid #D9D9D9', borderLeft: '2px solid #D9D9D9', borderRight: '2px solid #D9D9D9', borderBottom: tabIndex === index ? '2px solid #EEF2F6' : '2px solid white' }}>
                                        {/* <div className='w-[20px] h-[20px] bg-[#eee] rounded-[7px]'>
                                            {page?.icon && <img src={page?.icon} alt='icon' className='w-full h-full object-cover' />}
                                        </div> */}
                                        <div className='font-[900]' style={{ color: tabIndex == index ? 'black' : 'black',fontSize:isMobile?12:16 }}>{page?.name}</div>
                                    </div>
                                    : <div key={page?.id || index} />
                            )}
                        </div>
                        <div className='w-full flex flex-row bg-[white] items-center' style={{ borderBottom: isMobile?'2px solid #E3E3E3':'3px solid #E3E3E3',marginTop:isMobile?4:12,gap:isMobile?2:6,padding:isMobile?2:6 }}>
                            <div className='cursor-pointer'>
                                <PreviousSvg height={isMobile?18:30} width={isMobile?18:30} />
                            </div>
                            <div className='cursor-pointer'>
                                <NextSvg height={isMobile?18:30} width={isMobile?18:30} />
                            </div>
                            <div className='cursor-pointer'>
                                <ReloadSvg height={isMobile?18:30} width={isMobile?18:30} />
                            </div>
                            <div className='flex-1'>
                                <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={mission?.pages?.[tabIndex]?.url || 'xxx.yyy.com'} style={{fontSize:isMobile?10:16,height:isMobile?26:40,paddingLeft:isMobile?12:24,paddingRight:isMobile?12:24}} />
                            </div>
                        </div>
                        {/*end tabs*/}

                        {/*web content*/}
                        <div className='flex w-full flex-1 bg-[white]' style={{ overflowY: 'auto' }}>

                            <div className='w-full flex flex-col'>
                                {mission?.pages?.[tabIndex]?.contents?.map((item, index) =>
                                    <div key={index} className='w-full flex flex-col rounded-[7px] gap-[8px]'>
                                        {item?.type?.includes('文章標題') && <div className='flex flex-col w-full gap-[8px]'>
                                            <div className={`px-[16px] font-[700]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '文章標題(左對齊)' ? 'left' : item.type === '文章標題(居中對齊)' ? 'center' : 'right' }}>
                                                <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent", fontSize: isMobile?24:32 }} />
                                            </div>
                                        </div>}
                                        {item?.type?.includes('閱讀文章內容') && <div className='flex flex-col w-full gap-[8px]'>
                                            <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: item.type === '閱讀文章內容(左對齊)' ? 'left' : item.type === '閱讀文章內容(居中對齊)' ? 'center' : 'right' }}>
                                                <MDEditor.Markdown wrapperElement={{ "data-color-mode": "light" }} source={item?.text || ''} style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" ,fontSize: isMobile?12:16}} />
                                            </div>
                                        </div>}
                                        {item?.type === '圖片' &&
                                            <div className='w-full flex flex-col'>
                                                {item?.photo && <div className='relative w-full flex flex-row justify-center p-[16px]' style={{ backgroundColor: item?.backgroundColor || 'white' }}>
                                                    {
                                                        item?.photo
                                                            ? <img style={{ height: 400, width: 400, objectFit: 'contain', maxWidth: '100%' }} src={item?.photo} alt='image' />
                                                            : <div></div>
                                                    }
                                                </div>}
                                            </div>
                                        }
                                        {item.type === '超連結' && <div className='flex flex-col w-full gap-[8px]'>
                                            <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                                <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }}>
                                                    <div className='inline' dangerouslySetInnerHTML={{ __html: (item.redirects?.[0] ? item?.text?.slice(0, item.redirects?.[0]?.start) : item?.text) || '' }} />
                                                    {item.redirects?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                    )?.map((r, ri) =>
                                                        <div className='inline' key={ri}>
                                                            <div className='inline text-[blue] cursor-pointer underline'
                                                                onClick={async () => {
                                                                    let newTabIndex = mission?.pages.findIndex(p => p.id == r.pageId)
                                                                    let mission_ = { ...mission }
                                                                    mission_.pages[newTabIndex].initial = true
                                                                    setmission(mission_)
                                                                    settabIndex(mission?.pages.findIndex(p => p.id == r.pageId))
                                                                }}
                                                                dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }}
                                                            />
                                                            <div className='inline' dangerouslySetInnerHTML={{
                                                                __html:
                                                                    item.redirects?.[ri + 1] ?
                                                                        item?.text.slice(r.end, item.redirects?.[ri + 1].start)
                                                                        : item?.text.slice(r.end)
                                                            }} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>}
                                        {item.type === '彈出視窗' && <div className='flex flex-col w-full gap-[8px]'>
                                            <div className={`px-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                                <div cl style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }}>
                                                    <div className='inline' dangerouslySetInnerHTML={{ __html: (item.popups?.[0] ? item?.text?.slice(0, item.popups?.[0]?.start) : item?.text) || '' }} />
                                                    {item.popups?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                    )?.map((r, ri) =>
                                                        <div className='inline' key={ri}>
                                                            <div className='inline text-[blue] cursor-pointer underline'
                                                                onClick={() => { setisShowPopup(r.text) }}
                                                                dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }}
                                                            />
                                                            <div className='inline' dangerouslySetInnerHTML={{
                                                                __html:
                                                                    item.popups?.[ri + 1] ?
                                                                        item?.text.slice(r.end, item.popups?.[ri + 1].start)
                                                                        : item?.text.slice(r.end)
                                                            }} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>}

                                    </div>
                                )}
                                <div className='w-full min-h-[64px]'></div>
                            </div>
                        </div>
                        {/*end of web content*/}
                    </div>

                    {/*end of webpages*/}
                </div>
                {/*end of content*/}

                {showReadySubmitPopup && <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
                    <div className='flex flex-col gap-[8px] bg-[white] rounded-[16px] max-w-[548px] w-full text-[black]' style={{ overflow: 'hidden' }}>
                        <div className='font-[700] bg-[#1F4CC8] text-[36px] w-full text-center py-[16px] text-white'>小提示:</div>
                        <div className='text-[30px] w-full text-center mt-[24px]'>如確定完成任務</div>
                        <div className='text-[30px] w-full text-center'>將不能再次修改答案</div>
                        <div className='w-full flex flex-row gap-[32px] my-[24px] items-center justify-center'>
                            <div onClick={handleSubmitTask} className='font-[700] text-[28px] cursor-pointer hover:text-[white] hover:bg-[#1F4CC8] px-[36px] py-[4px] rounded-[99px] text-[#1F4CC8]' style={{ border: '3px solid #1F4CC8' }}>
                                確定
                            </div>
                            <div onClick={() => { setshowReadySubmitPopup(false) }} className='font-[700] text-[28px] cursor-pointer hover:text-[white] hover:bg-[#1F4CC8] px-[36px] py-[4px] rounded-[99px] text-[#1F4CC8]' style={{ border: '3px solid #1F4CC8' }}>
                                返回
                            </div>
                        </div>
                    </div>
                </div>}
                {isShowInstruction && <Instructions close={() => { setisShowInstruction(false) }} />}
                {isShowPopup && <PopupWindow text={isShowPopup} onClose={() => { setisShowPopup(false) }} />}
            </div>
        )
    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            {/*buttons*/}
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
                <div className='text-[#1D1D41] text-d-24 font-[400] cursor-pointer' onClick={() => { navigate('/platform2/missions') }}>{`<`} 返回</div>
            </div>
            {/*end of buttons*/}

            <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap'>
                <div className='flex-[3] flex flex-col gap-[16px] min-w-[300px]'>
                    <div className='font-[700]'>閲讀任務: {data?.name}</div>
                    <div className='font-[400]'>簡介:<br />
                        <div className='w-full bg-[white] p-[16px] rounded-[10px] mt-[16px]'>
                            <MDEditor.Markdown source={data?.description || ''} style={{ fontSize: isMobile ? 12 : 16, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "white" }} />
                        </div>
                    </div>
                    <div className='flex flex-row gap-[16px]'>
                        <div onClick={handleStartMission} className='font-[700] cursor-pointer hover:opacity-[0.8] p-[16px] rounded-[7px] bg-[#8866ff] text-[white]'>
                            {mission ? '繼續任務' : '開始任務'}
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
